/* unplugin-vue-components disabled */import { render } from "./commands-desktop.vue?vue&type=template&id=792b6fcd&scoped=true"
import script from "./commands-desktop.vue?vue&type=script&lang=js"
export * from "./commands-desktop.vue?vue&type=script&lang=js"

import "./commands-desktop.vue?vue&type=style&index=0&id=792b6fcd&lang=stylus&scoped=true"

import exportComponent from "/home/runner/work/buzz-front/buzz-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-792b6fcd"],['__file',"src/components/chat-input-v2/commands-menu/commands-desktop.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "792b6fcd"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('792b6fcd', __exports__)) {
    api.reload('792b6fcd', __exports__)
  }
  
  module.hot.accept("./commands-desktop.vue?vue&type=template&id=792b6fcd&scoped=true", () => {
    api.rerender('792b6fcd', render)
  })

}


export default __exports__